/*
 * @Description: 蓝牙相关命令的配置
 * @Author: fengd
 * @LastEditors: fengd
 * @Date: 2019-03-25 16:37:16
 * @LastEditTime: 2019-06-28 16:27:02
 */
export default {
  // 获取版本号
  version: {
    desc: '查询版本号',
    test(cmd) {
      return /^version/.test(cmd);
    },
    command(target) {
      return target ? `version ${target}` : 'version';
    },
    expect: 'version='
  },
  // 重启（不断电）
  reboot: {
    desc: '重启',
    test(cmd) {
      return cmd.indexOf('cpu1') !== -1 ? false : /^reboot/.test(cmd);
    },
    command(module) {
      return `reboot ${module}`;
    },
    expect: '',
    logBack: false
  },
  rebootCpu1: {
    desc: '重启cpu1',
    test(cmd) {
      return /^reboot cpu1/.test(cmd);
    },
    command(module) {
      return `reboot ${module}`;
    },
    expect: 'frank.mode=',
    logBack: true
  },
  // 断电重启（硬重启）
  reset: {
    desc: '重置',
    test(cmd) {
      return /^reset/.test(cmd);
    },
    command(module) {
      return `reset ${module}`;
    },
    expect: '' // cpu2执行时返回与蓝牙返回不一致
  },
  // 设置参数
  setParam: {
    desc: '设置参数',
    test(cmd) {
      return /^set/.test(cmd);
    },
    command(key, value) {
      return `set ${key}=${value}`;
    },
    expect: ''
  },
  // 查询参数
  getParam: {
    desc: '查询参数',
    test(cmd) {
      return /^prt/.test(cmd);
    },
    command(param) {
      return `prt ${param}`;
    },
    // 解析参数
    deparam(data) {
      // TODO 添加参数解析
    }
  },
  // 设置运行状态
  gotoRunState: {
    desc: '设置运行状态',
    test(cmd) {
      return /^goto/.test(cmd);
    },
    command(state) {
      return `goto ${state}`;
    },
    expect: 'goto'
  },
  // 测试组件
  test: {
    desc: '测试组件',
    test(cmd) {
      return /^test/.test(cmd);
    },
    command(module) {
      return `test ${module}`;
    },
    expect: 'test ok'
  },
  // 安装初始化
  init: {
    desc: '初始化',
    test(cmd) {
      return /^init/.test(cmd);
    },
    command(module) {
      return `init ${module}`;
    },
    expect: 'init ok'
  },
  // 升级组件
  upgrade: {
    desc: '升级',
    test(cmd) {
      return /^upgrade/.test(cmd);
    },
    command(module, channel) {
      return `upgrade ${module} ${channel}`;
    },
    expect: 'upgrade'
  },
  alterIP: {
    desc: '修改ip',
    test(cmd) {
      return /^ip/.test(cmd);
    },
    command(ip) {
      return `ip ${ip.replace(/[.:]/g, ' ')}`;
    },
    expect: ''
  },
  quitShutdown: {
    desc: '退出低电保护',
    test(cmd) {
      return /^quit shutdown/.test(cmd);
    },
    command(module) {
      return module;
    },
    expect: 'quit shutdown'
  },
  synctime: {
    desc: '校准地磁与调试手机时间',
    test(cmd) {
      return /^synctime/.test(cmd);
    },
    command(module) {
      return `synctime ${module}`;
    },
    expect: 'synctime'
  },
};
